module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-BlackItalic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-BlackItalic.ttf
// module id = 1888
// module chunks = 0